import { formatMoney as formatMinorUnits } from '@sbg/shared/pricing';

/** The BCP-47 tag handed to `Intl` (India-first number grouping: 12,34,567). */
const INTL_LOCALE = 'en-IN';

export const intlLocale = (): string => INTL_LOCALE;

// `Intl` constructors are comparatively expensive: build each options set once.
const numberFormats = new Map<string, Intl.NumberFormat>();
const dateFormats = new Map<string, Intl.DateTimeFormat>();

export function formatNumber(value: number, options?: Intl.NumberFormatOptions): string {
  const cacheKey = JSON.stringify(options ?? {});
  let format = numberFormats.get(cacheKey);
  if (!format) {
    format = new Intl.NumberFormat(INTL_LOCALE, options);
    numberFormats.set(cacheKey, format);
  }
  return format.format(value);
}

export function formatDate(
  value: Date | string | number,
  options: Intl.DateTimeFormatOptions = { dateStyle: 'medium' },
): string {
  const cacheKey = JSON.stringify(options);
  let format = dateFormats.get(cacheKey);
  if (!format) {
    format = new Intl.DateTimeFormat(INTL_LOCALE, options);
    dateFormats.set(cacheKey, format);
  }
  return format.format(new Date(value));
}

/** Money is integer minor units (paise): `123400` → `₹1,234` (paise shown only when present). */
export function formatMoney(minor: number, currency = 'INR'): string {
  return formatMinorUnits(minor, currency, INTL_LOCALE);
}
